import { StateUtils } from '@spartacus/core';
import { LoginForm } from '@user/const';
import { LOGIN, SUBMIT_AUTH_CODE } from '../user-state';

export const REQUEST_AUTH_CODE = '[Login API] Request auth code';
export const REQUEST_AUTH_CODE_SUCCESS = '[Login API] Request auth code Success';
export const REQUEST_AUTH_CODE_FAIL = '[Login API] Request auth code Failure';
export const REQUEST_AUTH_CODE_RESET = '[Login API] Request auth code Reset State';
export const SUBMIT_AUTH_CODE_REQUEST = '[Login API] Submit auth code Request';
export const SUBMIT_AUTH_CODE_SUCCESS = '[Login API] Submit auth code Success';
export const SUBMIT_AUTH_CODE_FAIL = '[Login API] Submit auth code Failure';
export const SUBMIT_AUTH_CODE_RESET = '[Login API] Submit auth code Reset State';

export class RequestAuthCode extends StateUtils.LoaderLoadAction {
  readonly type = REQUEST_AUTH_CODE;

  constructor(
    public phone: string,
    public deliveryChannel: string | undefined,
  ) {
    super(LOGIN);
  }
}
export class RequestAuthCodeSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = REQUEST_AUTH_CODE_SUCCESS;

  constructor(public payload: LoginForm) {
    super(LOGIN);
  }
}
export class RequestAuthCodeFailure extends StateUtils.LoaderFailAction {
  readonly type = REQUEST_AUTH_CODE_FAIL;

  constructor(public payload: unknown) {
    super(LOGIN, payload);
  }
}

export class RequestAuthCodeResetState extends StateUtils.LoaderResetAction {
  readonly type = REQUEST_AUTH_CODE_RESET;

  constructor() {
    super(LOGIN);
  }
}

// Подтверждение кода из смс
export class SubmitAuthCode extends StateUtils.LoaderLoadAction {
  readonly type = SUBMIT_AUTH_CODE_REQUEST;

  constructor(public code: string) {
    super(SUBMIT_AUTH_CODE);
  }
}
export class SubmitAuthCodeSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = SUBMIT_AUTH_CODE_SUCCESS;

  constructor() {
    super(SUBMIT_AUTH_CODE);
  }
}
export class SubmitAuthCodeFailure extends StateUtils.LoaderFailAction {
  readonly type = SUBMIT_AUTH_CODE_FAIL;

  constructor(public payload: unknown) {
    super(SUBMIT_AUTH_CODE, payload);
  }
}

export class SubmitAuthCodeResetState extends StateUtils.LoaderResetAction {
  readonly type = SUBMIT_AUTH_CODE_RESET;

  constructor() {
    super(SUBMIT_AUTH_CODE);
  }
}

export type LoginActions =
  | RequestAuthCode
  | RequestAuthCodeSuccess
  | RequestAuthCodeFailure
  | RequestAuthCodeResetState;
